import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomerOverViewService } from '../../customer-overview.service';
import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';
import { PaginatedTableComponent } from '~shared/components/tables/paginated-table/paginated-table.component';
import { Customer, Order, SidebarOptions } from '~core/models';
import { CustomerService, MerchandisingService, NavigationService, ScreenSizeService } from '~core/services';
import { SidebarService } from '~core/components/sidebar/sidebar.service';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';

/**
 * This component is the page that views only the merchandising
 */
@UntilDestroy()
@Component({
  selector: 'app-merchandising-page',
  templateUrl: './merchandising-page.component.html',
  styleUrls: ['../../customer-overview.component.scss']
})
export class MerchandisingPageComponent implements OnInit, OnDestroy {
  @ViewChild(PaginatedTableComponent) paginatedTable: PaginatedTableComponent;
  public customer: Customer;

  public orders: Array<Order>;
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public options: UntypedFormGroup;

  public baseApi: string;
  public customQueries: Array<any> = [];
  public defaultCustomQueries: Array<any> = [];

  constructor(
    public customerOverviewService: CustomerOverViewService,
    public customerService: CustomerService,
    public sidebarService: SidebarService,
    public route: ActivatedRoute,
    public navigationService: NavigationService,
    public ordersService: MerchandisingService,
    private screenSizeService: ScreenSizeService,
    public tablesTranslations: TablesTranslations,
    public flTranslations: FormLabelTranslationService,
    private formBuilder: UntypedFormBuilder,
  ) {
    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }
    this.navigationService.setCurrentPage('merchandising');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'customerProfile']);
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this))
      .subscribe(customer => this.customer = customer);

    this.columns.push(this.tablesTranslations.i18nDate, this.tablesTranslations.i18nMerchandising,
      this.tablesTranslations.i18nProducts, this.tablesTranslations.i18nQuantity, this.tablesTranslations.i18nAmount);
    this.keys.push(['purchaseDateTime', 'invoiceNumber', 'orderItems', 'quantity', 'fullPrice']);
  }

  public ngOnInit(): void {
    this.getCustomerOrdersEndpoint(this.customer.id);

    this.options = this.formBuilder.group({
      searchBy: ['', [Validators.minLength(2)]]
    });
  }

  public ngOnDestroy(): void {
    this.customerOverviewService.toggleAllModal(false);
  }

  public setNewOrdersList(orders: Array<any>): any {
    const data: Array<Order> = orders.map(order => new Order(order));
    this.orders = data;
  }

  public getCustomerOrdersEndpoint(id): void {
    const endpoint = this.ordersService.getCustomerOrdersEndpoint(id);
    this.baseApi = endpoint[0];
    this.customQueries = endpoint[1];
    this.defaultCustomQueries = [...this.customQueries];
  }

  /**
   * Triggers the search and updates the custom queries
   */
  public triggerSearch(): void {
    this.customQueries.length = 0;
    this.customQueries.push(...this.defaultCustomQueries);
    this.customQueries.push(this.options.value);
    this.paginatedTable.refetchData();
  }
}
